import { BlocksIconZoomOut } from 'blocks-nextjs/blocks-web-components/components/icon/icons/zoom-out';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconZoomOut = createComponent({ react: React, tagName: 'cat-icon-zoom-out', elementClass: BlocksIconZoomOut });
